import { PARTNER_TYPES } from '@/constants/partner-types';

/**
 * A fleet-only user carries no partner type other than FLEET_PARTNER and is not ryd-internal.
 * A fleet partner that also integrates the APIs (FLEET_PARTNER + API_PARTNER) is not fleet-only.
 * Menu items with `fleetOnlyPartnerFeature` stay hidden for these users until the partner flag is on.
 */
export function isFleetOnlyPartnerUser(
  partnerTypes: string[] | null | undefined,
  userGroup?: string | null,
): boolean {
  const types = partnerTypes || [];
  if (userGroup === 'ryd') return false;
  return types.length > 0 && types.every((type) => type === PARTNER_TYPES.FLEET_PARTNER);
}

/** Menu gate for `fleetOnlyPartnerFeature`; mirrored by both sidebars in `navmenu.vue`. */
export function passesFleetOnlyPartnerFeature(
  item: { fleetOnlyPartnerFeature?: string },
  partnerTypes: string[] | null | undefined,
  userGroup: string | null | undefined,
  featureFlags: Record<string, boolean> | null | undefined,
): boolean {
  if (!item.fleetOnlyPartnerFeature) return true;
  if (!isFleetOnlyPartnerUser(partnerTypes, userGroup)) return true;
  return (featureFlags || {})[item.fleetOnlyPartnerFeature] === true;
}
